import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var inputStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  &.MuiInputBase-root.Mui-error {\n    border-color: var(--border-error-dark);\n  }\n\n  &.Mui-disabled .MuiInputBase-input {\n    color: var(--text-placeholder);\n  }\n\n  .MuiInputBase-input::placeholder {\n    opacity: 1;\n  }\n"])));
var minHeight40 = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  min-height: 4rem;\n"])));
var minHeight48 = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  min-height: 4.8rem;\n"])));
var py11 = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  padding-top: 1.1rem;\n  padding-bottom: 1.1rem;\n"])));

export { inputStyles, minHeight40, minHeight48, py11 };
//# sourceMappingURL=styles.js.map
